import { render, staticRenderFns } from "./GlobalCustomers.vue?vue&type=template&id=39a77430&scoped=true&"
import script from "./GlobalCustomers.vue?vue&type=script&lang=js&"
export * from "./GlobalCustomers.vue?vue&type=script&lang=js&"
import style0 from "./GlobalCustomers.vue?vue&type=style&index=0&id=39a77430&prod&lang=scss&"
import style1 from "./GlobalCustomers.vue?vue&type=style&index=1&id=39a77430&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39a77430",
  null
  
)

export default component.exports